import {AchievementFiles} from "./AchievementFiles";

export class OtherAchievements {
  other_achievements_files: AchievementFiles[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/personal-achievements/OtherAchievements.ts